import { Divider, Stack, Typography } from "@mui/material";
import { ExportAccountsDataBtn } from "../../export-data";
import { useGetCampaignSummaryQuery } from "../../../../api";

export const MismatchDataDesktopWrapper = ({
  children,
  setIsVisible,
  isFirstUpload,
  isDisabled,
  campaign_id,
}: {
  children: JSX.Element;
  setIsVisible?: (visible: boolean) => void;
  isFirstUpload: boolean;
  isDisabled: boolean;
  campaign_id: string;
}) => {
  const { data } = useGetCampaignSummaryQuery({ campaign_id });

  return (
    <Stack gap="16px">
      {isFirstUpload && (
        <Typography
          component="span"
          variant="subtitle1"
          color="custom.textDarkBlue"
          fontWeight={500}
        >
          Upload Data
        </Typography>
      )}

      {children}
      <Divider />
      <Stack gap="8px">
        <Typography
          component="span"
          variant="subtitle1"
          color="custom.textDarkBlue"
          fontWeight={500}
        >
          Export Data
        </Typography>
        <Typography component="span" variant="body1" color="#4C545B">
          Export the campaign data in a structured CSV file.
        </Typography>
      </Stack>
      <ExportAccountsDataBtn
        isDisabled={isDisabled || data?.total_accounts_analyzed === 0}
        setIsVisible={setIsVisible}
        btnFullWidth={true}
        btnText="Export Data to CSV"
      />
    </Stack>
  );
};
